import { Button, StandardTable } from "react3l-ui-library";
import { useTranslation } from "react-i18next";
import { Close16 } from "@carbon/icons-react";
import { useAppUserHistoryDetailHook } from "./AppUserPermissionHistoryDetailHook";

function AppUserPermissionHistoryDetail() {
  const [translate] = useTranslation();
  const { handleGoBack, columns, appUserRoles, arrHistory, checkPath } = useAppUserHistoryDetailHook();

  return (
    <div className="page-content page-content-dxg" id={"page-content-dxg-id"}>
      <div className="info-component ml-4 mb-3">
        <span>{translate("appUsers.master.header")}</span>
        <span> &gt; </span>
        <span className="info-primary">
          {translate("general.actions.viewHistory")}
        </span>
      </div>
      <div className="page page-history mt-0">
        <div className="pt-3 pb-1 ml-3 d-flex justify-content-between">
          <h5 className="font-bold page-title">
            {translate("general.actions.viewHistory")}
          </h5>
          <div className="mr-3">
            <Button
              type="secondary"
              className="btn--lg btn-red"
              icon={<Close16 />}
              onClick={handleGoBack}
            >
              {translate("general.actions.close")}
            </Button>
          </div>
        </div>
        <div className="page-history__detail">
          <div className="w-100">
            <div className="page-history-detail__title p-t--xxl p-b--sm ml-3">
              <h5>{translate("appUsers.sitePermission.role")}</h5>
            </div>
            <StandardTable
              rowKey={"rowId"}
              columns={columns}
              dataSource={checkPath ? arrHistory : appUserRoles}
              tableSize={"md"}
              bordered
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AppUserPermissionHistoryDetail;
